import React from 'react';
import { FadeIn } from './FadeIn';
import { Star } from 'lucide-react';
export function SocialProof() {
  const testimonials = [{
    quote: 'We saw moments we missed!',
    author: 'Sarah & Mark',
    event: 'Wedding'
  }, {
    quote: 'Super easy for guests to use.',
    author: 'Jessica T.',
    event: 'Baby Shower'
  }, {
    quote: 'Best idea for weddings & parties.',
    author: 'Elena R.',
    event: 'Quinceañera'
  }];
  return <section className="py-14 md:py-24 px-5 bg-dark relative overflow-hidden" data-id="element-142">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold/20 to-transparent" data-id="element-143"></div>

      <div className="max-w-6xl mx-auto" data-id="element-144">
        <FadeIn className="text-center mb-8 md:mb-16" data-id="element-145">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-cream mb-4" data-id="element-146">
            Why Everyone <span className="text-gold italic" data-id="element-147">Loves</span>{' '}
            TapShare
          </h2>
          <div className="flex justify-center gap-1" data-id="element-148">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 text-gold fill-gold" data-id="element-149" />)}
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-4 md:gap-8" data-id="element-150">
          {testimonials.map((testimonial, index) => <FadeIn key={index} delay={0.2 * index} className="bg-dark-lighter p-8 rounded-2xl border border-gold/20 relative" data-id="element-151">
              <div className="absolute -top-4 left-8 text-6xl text-gold/20 font-heading" data-id="element-152">
                "
              </div>
              <p className="text-xl text-cream mb-6 relative z-10 font-light italic" data-id="element-153">
                "{testimonial.quote}"
              </p>
              <div className="mt-auto" data-id="element-154">
                <p className="text-gold font-medium" data-id="element-155">{testimonial.author}</p>
                <p className="text-sm text-cream-dark/50" data-id="element-156">
                  {testimonial.event}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}